const SET_RESOURCE = 'SET_RESOURCE';
const SET_RESOURCE_FIELDS = 'SET_RESOURCE_FIELDS';
const SET_REQUEST_FIELDS = 'SET_REQUEST_FIELDS';
const CLEAR_RESOURCE = 'CLEAR_RESOURCE';
const SET_INITIAL_RESOURCE_FILTER = 'SET_INITIAL_RESOURCE_FILTER';
const UPDATE_RESOURCE_FILTER_VALUES = 'UPDATE_RESOURCE_FILTER_VALUES';
const UPDATE_RESOURCE_SQL_FILTER = 'UPDATE_RESOURCE_SQL_FILTER';
const CLEAR_RESOURCE_FILTERS = 'CLEAR_RESOURCE_FILTERS';
const SET_INITIAL_RESOURCE_LIST_COLUMNS = 'SET_INITIAL_RESOURCE_LIST_COLUMNS';
const ADD_RESOURCE_LIST_COLUMN = 'ADD_RESOURCE_LIST_COLUMN';
const REMOVE_RESOURCE_LIST_COLUMN = 'REMOVE_RESOURCE_LIST_COLUMN';
const SET_DISPATCH = 'SET_DISPATCH'

export default {
  SET_RESOURCE,
  SET_DISPATCH,
  SET_RESOURCE_FIELDS,
  SET_REQUEST_FIELDS,
  CLEAR_RESOURCE,
  SET_INITIAL_RESOURCE_FILTER,
  UPDATE_RESOURCE_FILTER_VALUES,
  UPDATE_RESOURCE_SQL_FILTER,
  CLEAR_RESOURCE_FILTERS,
  SET_INITIAL_RESOURCE_LIST_COLUMNS,
  ADD_RESOURCE_LIST_COLUMN,
  REMOVE_RESOURCE_LIST_COLUMN
};



// WEBPACK FOOTER //
// ./src/redux/resource/types.js